import { render, staticRenderFns } from "./DashboardCustomizeSideSheet.vue?vue&type=template&id=6797d382&scoped=true"
import script from "./DashboardCustomizeSideSheet.vue?vue&type=script&lang=js"
export * from "./DashboardCustomizeSideSheet.vue?vue&type=script&lang=js"
import style0 from "./DashboardCustomizeSideSheet.vue?vue&type=style&index=0&id=6797d382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797d382",
  null
  
)

export default component.exports